module.exports = __webpack_public_path__ + "img/1546.ae0cde27.gif";